import { render, staticRenderFns } from "./SchemeEdit.vue?vue&type=template&id=68faaa82&scoped=true&"
import script from "./SchemeEdit.vue?vue&type=script&lang=js&"
export * from "./SchemeEdit.vue?vue&type=script&lang=js&"
import style0 from "./SchemeEdit.vue?vue&type=style&index=0&id=68faaa82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68faaa82",
  null
  
)

export default component.exports